import { useAppSelector } from "@/redux/store.ts";

export default function useCurrentProduct() {
    const currentProductReference = useAppSelector((state) => state.products.currentProductReference);
    const products = useAppSelector((state) => state.products.items);

    if (currentProductReference === null) return null;

    return products[currentProductReference] ?? null;
}
